// components/LoginModal.tsx
import React, { memo } from "react";
import { Modal, Form, Input, Button, Col } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LogoBg from "../../../assets/images/logo/benchmarklogo.png";

interface LoginModalProps {
  isOpen: boolean;
  submitting: boolean;
  form: any;
  onCancel: () => void;
  onLogin: (values: any) => void;
}

export const LoginModal = memo<LoginModalProps>(({
  isOpen,
  submitting,
  form,
  onCancel,
  onLogin,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      title="Login"
      open={isOpen}
      footer={null}
      style={{ top: 20 }}
      onCancel={onCancel}
    >
      <Form
        layout="vertical"
        form={form}
        name="login-form"
        initialValues={{
          autoLogin: true,
          email: "",
          password: "",
        }}
        style={{ padding: "20px" }}
        onFinish={onLogin}
      >
        <Col style={{ textAlign: "center", marginBottom: "20px" }}>
          <img src={LogoBg} height={100} alt="Logo" />
        </Col>

        <Form.Item
          label="Email / Username *"
          name="email"
          rules={[
            { type: "string", message: "The input is not a valid e-mail" },
            {
              required: true,
              message: "Please input your email or username!",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Email or username"
          />
        </Form.Item>

        <Form.Item
          label="Password *"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>

        <Form.Item>
          <a
            className="login-form-forgot"
            onClick={() => {
              onCancel();
              navigate("/user/forgot/reset");
            }}
          >
            Forgot password
          </a>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            loading={submitting}
            style={{
              background:
                "linear-gradient(90deg, rgba(137,33,107,1) 0%, rgba(137,33,107,1) 35%, rgba(218,68,83,1) 100%)",
              padding: "0px",
            }}
          >
            Login
          </Button>

          <Form.Item className="center-text">
            <span>Don't have an account? </span>
            <a onClick={() => navigate("/user/register/new")}>Sign up</a>
          </Form.Item>
        </Form.Item>
      </Form>
    </Modal>
  );
});